import { WalletButton } from "@vechain/dapp-kit-react";

export default function LayoutMenu() {
    return (
        <WalletButton />
    )
}